import { atomWithReset } from "jotai/utils";

export const productUsageModalAtom = atomWithReset<{
  visible: boolean;
  orderItemId: number | null;
}>({
  visible: false,
  orderItemId: null
});
